import api from "../axios";

export interface QuoteAnswers {
  usResident: boolean;
  firstTimeRenter?: boolean;
  bestDescription?:
    | "self-employed"
    | "relocating"
    | "student-retired"
    | "other";
  nonUsBestDescription?: "currently-employed" | "student" | "other";
  annualIncome?: number;
  monthlyRent?: number;
  /** Required for US-resident underwriting; ignored otherwise. */
  ssn?: string;
}

export interface QuoteResult {
  quote: number;
  quoteMonthly: number;
  quoteMonthlyWithoutDiscount: number;
  monthlyInstallments: number;
  termLengthDecimal: number;
  termLength: number;
  policyFee: number;
  tax: number;
  stampingFee: number;
  lateFee: number;
  companyPolicyFee: number;
  coverageStartDate: string;
  coverageEndDate: string;
  coverageAmount: number;
  creditCardBillingFee: number;
  billingFee: number;
  total: number;
  version: number;
}

export function calculateMyQuote(
  inviteUuid: string,
  answers: QuoteAnswers,
) {
  return api.post<QuoteResult>("/quote", { inviteUuid, ...answers });
}
